import { useEffect, useState } from 'react';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

export const useKeyboardOpen = (): boolean => {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return;

        let showSub: PluginListenerHandle | null = null;
        let hideSub: PluginListenerHandle | null = null;

        const handleKeyboardShow = () => {
            setIsKeyboardOpen(true);
            document.body.classList.add('keyboard-open');
        };

        const handleKeyboardHide = () => {
            setIsKeyboardOpen(false);
            document.body.classList.remove('keyboard-open');
        };

        const registerListeners = async () => {
            showSub = await Keyboard.addListener('keyboardWillShow', handleKeyboardShow);
            hideSub = await Keyboard.addListener('keyboardWillHide', handleKeyboardHide);
        };

        registerListeners();

        return () => {
            showSub?.remove();
            hideSub?.remove();
        };
    }, []);

    return isKeyboardOpen;
};
